export const provinceConfig = [
    { id: 'ZH', name: 'Zurich' },
    { id: 'BE', name: 'Bern' },
    { id: 'LU', name: 'Lucerne' },
    { id: 'UR', name: 'Uri' },
    { id: 'SZ', name: 'Schwyz' },
    { id: 'OW', name: 'Obwalden' },
    { id: 'NW', name: 'Nidwalden' },
    { id: 'GL', name: 'Glarus' },
    { id: 'ZG', name: 'Zug' },
    { id: 'FR', name: 'Fribourg' },
    { id: 'SO', name: 'Solothurn' },
    { id: 'BS', name: 'Basel Stadt' },
    { id: 'BL', name: 'Basel Land' },
    { id: 'SH', name: 'Schaffhausen' },
    { id: 'AR', name: 'Appenzell Ausserrhoden' },
    { id: 'AI', name: 'Appenzell Innerrhoden' },
    { id: 'SG', name: 'Sankt Gallen' },
    { id: 'GR', name: 'Graubünden' },
    { id: 'AG', name: 'Aargau' },
    { id: 'TG', name: 'Thurgau' },
    { id: 'TI', name: 'Ticino' },
    { id: 'VD', name: 'Vaud' },
    { id: 'VS', name: 'Valais' },
    { id: 'NE', name: 'Neuchâtel' },
    { id: 'GE', name: 'Genève' },
    { id: 'JU', name: 'Jura' }
];
export const countryConfig = [
    { id: 'CH', name: 'Switzerland' },
    { id: 'IT', name: 'Italy' },
    { id: 'FR', name: 'France' },
    { id: 'DE', name: 'Germany' },
];
